<template>
  <div>
    <b-modal
      :id="`edit-user-${id}`"
      :title="`${this.$t('menu.settings.users.titleUpdateUser')}`"
      size="lg"
    >
      <div class="row">
        <div class="col-5">
          <p style="font-size: 12px;">
            Criado por:
            {{
              user.createdBy.name ? `${user.createdBy.name} ${user.createdAt}` : '-'
            }}
            <br />
            Editado por:
            {{
              user.updatedBy.name ? `${user.updatedBy.name} ${user.updatedAt}` : '-'
            }}
          </p>
        </div>
        <div v-if="user.loginAttempt === 5" class="col-7">
          <div style="background: red; align-items: center; display: flex; justify-content: center; padding: 8px;">
            <span style="color: white;">
              Este usuário esta bloqueado por excesso de tentativas.<br />
              Clique
              <a @click="unlockUser(user._id)"
                ><strong style="color: white; cursor: pointer"><u>AQUI</u></strong></a
              >
              para desbloqueá-lo.
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for="modal-user-name"
              >{{ this.$t('menu.settings.users.labels.nameUser') }}:</label
            >

            <input
              type="text"
              v-model="user.name"
              id="modal-user-name"
              class="form-control"
              placeholder="Nome do usuário"
              @keyup="removeInvalidClass('modal-user-name')"
            />
            <div class="invalid-feedback">
              {{ $t('menu.settings.users.invalidFeedbackName') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for="modal-user-email">
              {{ this.$t('menu.settings.users.labels.email') }}:</label
            >
            <input
              type="email"
              v-model="user.email"
              id="modal-user-email"
              class="form-control"
              :placeholder="`${this.$t(
                'menu.settings.users.placeholderEmailUser',
              )}`"
              @keyup="removeInvalidClass('modal-user-email')"
            />
            <div class="invalid-feedback">
              {{ $t('menu.settings.users.invalidFeedbackEmail') }}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="modal-user-phone"
              >{{ this.$t('menu.settings.users.labels.phone') }}:</label
            >
            <input
              type="text"
              v-model="user.celPhone"
              id="modal-user-phone"
              class="form-control"
              :placeholder="`${this.$t(
                'menu.settings.users.placeholderPhoneUser',
              )}`"
              v-mask="'+## (##) #####-####'"
              @keyup="removeInvalidClass('modal-user-phone')"
            />
            <div class="invalid-feedback">
              {{ $t('menu.settings.users.invalidFeedbackPhone') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for="modal-user-position"
              >{{ $t('menu.settings.users.labels.post') }}:</label
            >
            <input
              type="text"
              v-model="user.occupation"
              id="modal-user-position"
              class="form-control"
              :placeholder="`${this.$t(
                'menu.settings.users.placeholderPostUser',
              )}`"
              @keyup="removeInvalidClass('modal-user-position')"
            />
            <div class="invalid-feedback">
              {{ $t('menu.settings.users.invalidFeedbackPost') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for="modal-user-company">
              {{ $t('menu.settings.users.labels.company') }}:
            </label>
            <select
              class="form-control"
              multiple
              id="modal-user-company"
              v-model="selectedCompanies"
              disabled
            >
              <option
                v-for="(item, i) in companiesOptions"
                :value="item.value"
                :key="i"
              >
                {{ item.text }}
              </option>
            </select>
          </div>
        </div>
        <b-form-checkbox
          class
          id="treatments-responsible-edit"
          v-model="user.treatmentsResponsible"
        ></b-form-checkbox>
        <label for="treatments-responsible-edit">
          {{ $t('menu.settings.users.labels.responsible') }}</label
        >
      </div>
      <template v-slot:modal-footer="{ cancel }">
        <div class="w-100">
          <button
            v-b-modal="`modal-permissions-${id}`"
            @click="cancel(cancelar())"
            class="float-left btn btn-outline-primary"
          >
            {{ $t('menu.settings.users.buttonPermissons') }}
          </button>

          <template v-if="user.lastLogin === null">
            <b-button
              style="margin-left: 10px;"
              v-b-modal.modal-invite-user
              variant="outline-danger"
              >Convidar usuário</b-button
            >

            <b-modal
              id="modal-invite-user"
              title="Convidar usuário"
              size="lg"
              cancel-title="CANCELAR"
              ok-title="SIM"
              @ok="inviteUser(user)"
            >
              <p>Deseja convidar o usuário para a plataforma?</p>
            </b-modal>
          </template>

          <template
            v-if="userAuth.type === 'master' || userAuth.type === 'admin'"
          >
            <b-button
              style="margin-left: 8px;"
              v-b-modal.modal-reset-password
              variant="outline-danger"
              >Resetar senha</b-button
            >

            <b-modal
              id="modal-reset-password"
              title="Resetar senha"
              size="lg"
              cancel-title="CANCELAR"
              ok-title="SIM"
              @ok="resetPassword(user)"
            >
              <p>Deseja resetar a senha desse usuário?</p>
            </b-modal>
          </template>

          <button @click="edit" class="float-right btn btn-primary ml-2">
            {{ $t('menu.settings.users.buttonSave') }}
          </button>
          <button
            @click="cancel(cancelar())"
            class="float-right btn btn-outline-primary"
          >
            {{ $t('menu.settings.users.buttonCancel') }}
          </button>
        </div>
      </template>
    </b-modal>
    <modal-permissions
      :id="id"
      :user="{
        ...myUser,
        ih1: myUser.account.ih1,
        ih2: myUser.account.ih2,
      }"
      :page="page"
      :limit="limit"
      :filter="filter"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { lightFormat } from 'date-fns';
import validator from 'validator';
import swal from 'sweetalert';
import ModalPermissions from '../modal-permissions';
import api from '../../../services/api';
import eventBus from '../../../eventBus';

export default {
  props: ['id', 'myUser', 'page', 'limit', 'filter'],

  components: {
    ModalPermissions,
  },

  data: () => ({
    user: {},
    userAuth: null,
    formattedPhone: null,
    companiesOptions: [],
    selectedCompanies: [],
  }),

  computed: {
    ...mapState('settings', ['userPage']),
    ...mapState('master', ['allCompanies']),
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    if (this.userAuth.companyList && this.userAuth.companyList.length > 1) {
      for (let i = 1; i < this.allCompanies.length; i += 1) {
        if (
          this.userAuth.companyList.indexOf(this.allCompanies[i].value) !== -1
        ) {
          this.companiesOptions.push(this.allCompanies[i]);
        }
      }
    } else {
      for (let i = 1; i < this.allCompanies.length; i += 1) {
        if (this.userAuth.companyId === this.allCompanies[i].value) {
          this.companiesOptions.push(this.allCompanies[i]);
        }
      }
    }
  },

  mounted() {
    eventBus.$on('profile-attributes', () => {
      this.updateTable();
    });
    this.user = { ...this.myUser, treatmentsResponsible: this.myUser.account.treatmentsResponsible };

    const dayCreated = lightFormat(new Date(this.user.createdAt), 'dd/MM/yyyy');
    const hourCreated = lightFormat(new Date(this.user.createdAt), 'HH:mm');

    const dayUpdated = lightFormat(new Date(this.user.updatedAt), 'dd/MM/yyyy');
    const hourUpdated = lightFormat(new Date(this.user.updatedAt), 'HH:mm');

    this.user.createdAt = `${dayCreated} ${hourCreated}`;
    this.user.updatedAt = `${dayUpdated} ${hourUpdated}`;

    if (this.user.companyList && this.user.companyList.length > 1) {
      this.selectedCompanies = this.user.companyList;
    } else {
      this.selectedCompanies.push(this.user.companyId._id);
    }
  },
  beforeDestroy() {
    eventBus.$off('profile-attributes');
  },

  methods: {
    ...mapActions('settings', ['getUsers', 'editUserInfo']),
    ...mapActions('master', ['getAllCompanies']),

    unlockUser(idUser) {
      swal({
        title: 'Desbloquear usuário',
        text: 'Deseja realmente desbloquear este usuário?',
        icon: 'warning',
        buttons: [
          'Cancelar',
          'Confirmar',
        ],
        dangerMode: true,
      }).then(async (confirm) => {
        if (confirm) {
          await api.put(
            '/user/unlock',
            {
              id: idUser,
            },
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            },
          );

          swal({
            title: 'Sucesso',
            text: 'Usuário desbloqueado com sucesso',
            icon: 'success',
          });

          this.user.loginAttempt = 0;

          this.updateTable();
        }
      });
    },

    async resetPassword(user) {
      try {
        await api.post(
          '/user/reset-password',
          {
            email: user.email,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );

        swal({
          title: 'Sucesso',
          text: 'Email enviado com sucesso!',
          icon: 'success',
        });
      } catch (error) {
        swal({
          title: 'Error',
          text: 'Tente novamente mais tarde...',
          icon: 'warning',
        });
      }
    },

    async inviteUser(user) {
      try {
        await api.post(
          '/user/invite-user',
          {
            email: user.email,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );

        swal({
          title: 'Sucesso',
          text: 'Email enviado com sucesso!',
          icon: 'success',
        });
      } catch (error) {
        swal({
          title: 'Error',
          text: 'Tente novamente mais tarde...',
          icon: 'warning',
        });
      }
    },

    async updateTable() {
      await this.getUsers({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        userId: this.userAuth._id,
        page: this.page,
        limit: this.limit,
        filter: this.filter,
      });
    },

    edit(event) {
      if (this.validateFields()) {
        this.editUserInfo({
          token: this.userAuth.token,
          userId: this.myUser._id,
          data: {
            name: this.user.name,
            email: this.user.email,
            occupation: this.user.occupation,
            celPhone: this.user.celPhone,
            treatmentsResponsible: this.user.treatmentsResponsible,
            companyList: this.selectedCompanies,
            updatedBy: this.userAuth._id,
          },
        })
          .then(() => {
            this.updateTable();

            swal({
              title: this.$t('menu.settings.users.messages.savedChanges.text'),
              text: this.$t(
                'menu.settings.users.messages.savedChanges.description',
                {
                  userName: `${this.user.name}`,
                },
              ),
              icon: 'success',
            });
          })
          .catch((err) => {
            window.console.log(err);
            swal({
              title: this.$t('menu.settings.users.messages.failedUpdate.text'),
              text: this.$t(
                'menu.settings.users.messages.failedUpdate.description',
              ),
              icon: 'warning',
            });
          });
      } else {
        event.preventDefault();
      }
    },

    validateFields() {
      if (!this.user.name) {
        document.getElementById('modal-user-name').classList.add('is-invalid');
        return false;
      } else if (
        !this.user.email ||
        validator.isEmail(this.user.email) === false
      ) {
        document.getElementById('modal-user-email').classList.add('is-invalid');
        return false;

        // } else if (!this.user.celPhone) {
        //   document.getElementById('modal-user-phone').classList.add('is-invalid');
        //   return false;
      } else if (!this.user.occupation) {
        document
          .getElementById('modal-user-position')
          .classList.add('is-invalid');
        return false;
      } else if (this.selectedCompanies.length === 0) {
        document
          .getElementById('modal-user-company')
          .classList.add('is-invalid');
        return false;
      }

      // if (!this.formatNumber()) {
      //   return false;
      // }

      return true;
    },

    // formatNumber() {
    //   this.formattedPhone = '';
    //   for (let i = 0; i <= this.user.celPhone.length; i += 1) {
    //     if (
    //       parseInt(this.user.celPhone.charAt(i), 10) ||
    //       this.user.celPhone.charAt(i) === '0'
    //     ) {
    //       this.formattedPhone += this.user.celPhone.charAt(i);
    //     }
    //   }
    //   if (
    //     !parseInt(this.formattedPhone, 10) &&
    //     this.formattedPhone.length !== 13
    //   ) {
    //     document.getElementById('modal-user-phone').classList.add('is-invalid');
    //     return false;
    //   }
    //   return true;
    // },

    removeInvalidClass(id) {
      const element = document.getElementById(id);
      for (let i = 0; i <= element.classList.length; i += 1) {
        if (element.classList[i] === 'is-invalid') {
          element.classList.remove('is-invalid');
        }
      }
    },

    cancelar() {
      this.user = {
        ...this.myUser,
      };
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/molecules/modal-edit-user/index.vue